import { adConfigReceived, adConfigUnloaded } from 'redux-implementations/googleAds';
import { useDispatch } from 'react-redux';

import { useRouter } from 'next/router';
import { useDeepCompareEffect } from 'react-use';
import queryString from 'query-string';
import { setAdTargeting, clearAdTargeting, getAdSetup } from 'lib/GoogleAds/adManager';
import { Targeting } from '../GoogleAds';
// import useHashParamFeatureFlag from './useHashParamFeatureFlag';

const DISABLE_ADS_PARAM = 'disableAds';
const TEST_ADS_PARAM = 'test';

export default function useAdSetup(adUnit: string, targeting: Targeting): void {
  const dispatch = useDispatch();
  const { query } = useRouter();
  const queryFromBrowser =
    typeof window !== 'undefined' ? queryString.parse(window.location.search) : {};
  const adsDisabledParam = query[DISABLE_ADS_PARAM] || queryFromBrowser[DISABLE_ADS_PARAM];
  const testAdsParam = query[TEST_ADS_PARAM] || queryFromBrowser[TEST_ADS_PARAM];

  const isAdManagerEnabled = getAdSetup();

  useDeepCompareEffect(() => {
    if (isAdManagerEnabled) {
      setAdTargeting({
        ...targeting,
        // some pages dont send adUnit. We need to enforce this.
        adUnit,
      });
      return (): void => {
        clearAdTargeting();
      };
    }
    dispatch(
      adConfigReceived({
        adsDisabled: adsDisabledParam === 'true',
        adUnit,
        adTargeting: targeting,
      })
    );
    return (): void => {
      dispatch(adConfigUnloaded());
    };
  }, [adUnit, adsDisabledParam, dispatch, targeting, testAdsParam]);
}
